export enum RoutePath {
  Home = '/',
  Offers = '/oferty',
  Summary = '/podsumowanie',
  Error = '/blad',
  NotFound = '/nie-znaleziono',
  ThankYou = '/podziekowanie',
  CantInsure = '/nie-mozemy-wycenic',
  EarlyRenewalError = '/odnowienie/za-wczesnie',
  LateRenewalError = '/odnowienie/za-pozno',
  Retrieve = '/przywroc',
}
